import React from "react";
import { DatePicker, Col, Form, Row, Select } from "antd";
import locale from "antd/lib/date-picker/locale/ja_JP";
import * as moment from "moment-timezone";
import { observer } from "mobx-react";

import { FInput, FSelect } from "../../common/form";
import ChildrenTemplaceRender from "../ChildrenTemplateRender";
import Book from "../../models/Book";

moment.tz.setDefault("Asia/Tokyo");

const Option = Select.Option;

const Input = ({ label, span, ...props }) => (
  <Col span={span}>
    <FInput label={label} {...props} />
  </Col>
);

let isOverOneYear = false; // シカケテガミに刻印する記念日を1年後を選択した時、吹き出しで警告を表示させる

// 文字数制限を超えているか
let isCNameTooLong = false;
const CNameLimit = 10;
let isRNameTooLong = false;
const RNameLimit = 6;
let isCookingTooLong = false;
const CookingLimit = 8;
let isChildNameTooLong = false;
const ChildNameLimit = 6;

class Informations extends React.Component {
  constructor() {
    super();
    this.state = {
      book: Book.create({})
    };
  }

  onChildNameChange = e => {
    let text = e.target.value;
    isChildNameTooLong = text.length > ChildNameLimit;
    this.state.book.changeChildName(text);
  };
  onChildrenChange = v => {
    isChildNameTooLong = false;
    this.state.book.changeChildName(''); // こどもの名前をリセット
    this.state.book.changeChildren(v);
  };
  onCNameChange = e => {
    let text = e.target.value;
    text = text.replace(/\u3000/g, " ");
    isCNameTooLong = text.length > CNameLimit;
    this.state.book.changeCreatorName(text);
  };
  onCookingChange = e => {
    let text = e.target.value;
    isCookingTooLong = text.length > CookingLimit;
    this.state.book.changeLikedHomeCooking(text);
  };
  onRNameChange = e => {
    let text = e.target.value;
    isRNameTooLong = text.length > RNameLimit;
    this.state.book.changeReceiverName(text);
  };
  onDateChange = date => {
    const today = moment();
    const nextYear = today.add(1, 'year');
    // console.log(date.isAfter(nextYear));
    isOverOneYear = date.isAfter(nextYear.subtract(1, 'days'));
    this.state.book.changeCustomDate(date.toDate());
  };

  updateABook(book, bookFrom) {
    book.changeChildName(bookFrom.childName);
    book.changeChildren(bookFrom.children);
    book.changeChildrenTemplate(bookFrom.childrenTemplate);
    book.changeCreatorName(bookFrom.creatorName);
    book.changeCustomDate(bookFrom.customDate);
    book.changeLikedHomeCooking(bookFrom.likedHomeCooking);
    book.changeReceiverName(bookFrom.receiverName);
  }

  onSave = () => {
    this.updateABook(this.props.book, this.state.book);
    this.setState({ lastSave: Date.now() });
    this.props.order.nextStep();
  };

  componentWillMount() {
    if (this.props.book) {
      this.updateABook(this.state.book, this.props.book);
    }
  }
  render() {
    const book = this.state.book;

    return (
      <div className="informations pd-15">
        <Form layout="vertical">
          <Row>
            <div style={{ padding: "0 0 8px" }}>
              {"あなたのお名前を教えてください。"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角10文字以内）"}
              </div>
              <p style={{ fontSize: "10px", color: "#c00" }}>
                {"※姓名の間に必ず半角スペースを入力してください。"}
              </p>
            </div>
            <div data-warning={isCNameTooLong}>
              <Input
                onChange={this.onCNameChange}
                placeholder="例）山田 太郎"
                span={24}
                size="large"
                style={{ fontSize: "14px" }}
                value={book.creatorName}
              />
            </div>
          </Row>
          <Row
            data-warning={isRNameTooLong}
            type="flex"
            justify="space-between"
          >
            <div>
              {"プレゼントする相手のことを普段何と呼んでいますか？"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角6文字以内）"}
              </div>
            </div>
            <Input
              span={24}
              onChange={this.onRNameChange}
              placeholder="例）花子、ハナ、花ちゃん、花子さん等"
              size="large"
              style={{ fontSize: "14px" }}
              value={book.receiverName}
            />
          </Row>
          <Row>
            <div>
              {"その方がつくるあなたの好きな手料理は何ですか？"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（全角8文字以内）"}
              </div>
            </div>
            <div data-warning={isCookingTooLong}>
              <Input
                span={24}
                onChange={this.onCookingChange}
                placeholder="例）カレーライス"
                size="large"
                style={{ fontSize: "14px" }}
                value={book.likedHomeCooking}
              />
            </div>
          </Row>
          <Row>
            <div>
              {(() => {
                const urlParams = new URLSearchParams(window.location.search);
                const hasKey = urlParams.has('key');
                return hasKey
                  ? "シカケテガミへの刻印日（挙式日など）をお選びください。"
                  : "シカケテガミに刻印する記念日をお選びください。";
              })()}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（本の最終ページに印字されます）"}
              </div>
              <p style={{ fontSize: "11px", padding: "0 0 8px", color: "#c00" }}>
                {"※ 商品のお届け日をお約束するものではございません。"}
              </p>
            </div>
            <div
              className="c-calenderConfirm"
              data-over={isOverOneYear ? 'true' : 'false'}
            >
              <div className="c-calenderConfirm__comment"><span></span></div>
              <DatePicker
                allowClear={false}
                locale={locale}
                disabledDate={m => m.valueOf() <= moment().subtract(90, 'day').valueOf()}
                onChange={this.onDateChange}
                size="large"
                style={{ fontSize: "14px" }}
                value={moment(book.customDate)}
              />
            </div>
          </Row>
          <br />
          <div className="label">（お子様についての情報）</div>
          <Row type="flex" justify="space-between">
            <Col span={11}>
              <div className="label">お子様の数</div>
              <FSelect
                defaultValue={`${book.children}`}
                onChange={this.onChildrenChange}
                size="large"
              >
                <Option value="0">0人</Option>
                <Option value="1">1人</Option>
                <Option value="2">2人</Option>
                <Option value="3">3人</Option>
              </FSelect>
            </Col>
            {book.children === 1 ? (
              <Col
                data-warning={isChildNameTooLong}
                span={11}
              >
                <Input
                  label="お子様の名前"
                  onChange={this.onChildNameChange}
                  value={book.childName}
                />
              </Col>
            ) : null}
          </Row>
          <ChildrenTemplaceRender book={book} />
          <div className="btn-wrap">
            <button
              className="btn product-btn"
              disabled={!book.isInfoSet ||
                isCNameTooLong ||
                isRNameTooLong ||
                isCookingTooLong ||
                isChildNameTooLong
              }
              onClick={this.onSave}
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default observer(Informations);



// WEBPACK FOOTER //
// ./src/components/steps/Informations.js